import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { ITplDestinering } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { IMinMax, ITplDestineringFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-avstand-filter",
    templateUrl: "./tpl-avstand-filter.component.html",
    styleUrls: ["./tpl-avstand-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        InputNumberComponent
    ]
})
export class TplAvstandFilterComponent extends FilterBaseComponent implements OnInit, ITplDestineringFilter {

    constructor() {
        super("avstand");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormGroup({
            min: new UntypedFormControl(null),
            max: new UntypedFormControl(null)
        }));
    }

    match(item: ITplDestinering): boolean {
        const value = this.value();
        return this.isBetween(item.transportavstand, value.min, value.max);
    }

    onFilterInit(state: IMinMax): void {
        state = state ?? { min: null,
            max: null };
        this.control.setValue(state);
    }

    value(): IMinMax {
        return this.control.value;
    }

    isActive(): boolean {
        return this.filterLength > 0;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        this.filterContext.addDestineringFilter(this.name, this);
    }

    protected onFormChange(value: IMinMax): void {
        this.filterLength = (value.min ? 1 : 0) + (value.max ? 1 : 0);
    }
}
